import type { CSSProperties } from 'react';
import styles from './ConfigCard.module.css';

interface ConfigCardProps {
	title: string;
	onConfigure: () => void;
	variant: 'gradient' | 'image';
	imageUrl?: string;
	decorativeText?: string[];
}

export const ConfigCard = ({
	title,
	onConfigure,
	variant,
	imageUrl,
	decorativeText,
}: ConfigCardProps) => {
	const inlineStyle: CSSProperties =
		variant === 'image' && imageUrl ? { backgroundImage: `url(${imageUrl})` } : {};

	return (
		<div
			className={`${styles.card} ${variant === 'gradient' ? styles.cardGradient : styles.cardImage}`}
			style={inlineStyle}
		>
			{variant === 'gradient' && (
				<div className={styles.decorativeOverlay} aria-hidden="true">
					<div className={styles.ellipseLeft} />
					<div className={styles.ellipseRight} />
					{decorativeText && (
						<div className={styles.decorativeTextWrapper}>
							{Array.isArray(decorativeText) ? (
								decorativeText.map((line, index) => (
									<span className={styles.decorativeTextArr} key={index}>
										{line}
									</span>
								))
							) : (
								<span className={styles.decorativeText}> {decorativeText}</span>
							)}
						</div>
					)}
				</div>
			)}

			<div className={styles.cardContent}>
				<h3 className={styles.cardTitle}>{title}</h3>
				<button
					type="button"
					className={`${styles.cardBtn} ${variant === 'gradient' ? styles.cardBtnGradient : styles.cardBtnImage}`}
					onClick={onConfigure}
				>
					Configurar
				</button>
			</div>
		</div>
	);
};
